import React, { useContext, useEffect } from "react";
import { Table, Button, Icon, Popup } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import {
  getDateFormatDDMMAAAA,
  getStateBetweenDates,
} from "../../../../app/util/dateOptions";
import DeleteCertificate from "./DeleteCertificate";
import LoadingComponent from "../../../../app/layout/LoadingComponent";

const ListCertificates = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    certificates,
    getCertificates,
    loadData,
  } = rootStore.certificateStore;
  const { openModal } = rootStore.modalStore;

  useEffect(() => {
    getCertificates();
  }, [getCertificates]);
  if (!loadData) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Fecha inicial autorizada</Table.HeaderCell>
          <Table.HeaderCell>Fecha final autorizada</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {certificates?.length > 0 ? (
          certificates.map((certificate) => (
            <Table.Row key={certificate.id}>
              <Table.Cell className="centertd" >
                {getDateFormatDDMMAAAA(certificate.startDate)}
              </Table.Cell>
              <Table.Cell className="centertd" >
                {getDateFormatDDMMAAAA(certificate.endDate)}
              </Table.Cell>
              <Table.Cell className="centertd" >
                {getStateBetweenDates(
                  certificate.startDate,
                  certificate.endDate
                )}
              </Table.Cell>
              <Table.Cell className="centertd" >
                <Popup
                  content={`Eliminar certificado`}
                  trigger={
                    <Button
                      icon
                      onClick={() =>
                        openModal(
                          <DeleteCertificate id={certificate.id} />,
                          "Eliminar certificado"
                        )
                      }
                    >
                      <Icon name="delete" color="red" />
                    </Button>
                  }
                />
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="certificatesNull">
            <Table.Cell>No existen certificados </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListCertificates);
